// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_EQQ","cls2":"SplitVerdictPreviewList-cls2_ORh SplitVerdictPreviewList-cls1_EQQ"};